/** @format */

/* eslint-disable */
import React from 'react'
import SimpleLookup from './SimpleLookup'
import localize from '../../Global/Localize'
import { formatDate } from '../../Helpers/formatters'

function TransactionReferenceLookup({ onSelect, displayValue }) {
  const columns = [
    {
      label: 'name',
      template: r => <>{r.description}</>,
    },
    {
      label: 'isLocked',
      template: r => <>{r.isLocked.toString()}</>,
    },
    {
      label: 'modifiedBy',
      template: r => <>{r.modifiedBy}</>,
    },
    {
      label: 'modifiedDate',
      template: r => <>{formatDate(r.modifiedDate)}</>,
    },
    {
      label: 'createdBy',
      template: r => <>{r.createdBy}</>,
    },
    {
      label: 'createdDate',
      template: r => <>{formatDate(r.createdDate)}</>,
    },
  ]
  return (
    <>
      <SimpleLookup
        columns={columns}
        title={localize('transactionReferenceLookup')}
        url="/lookup/TransactionReference/find-by-filter-in-page"
        params={{ filterText: '', pageIndex: 0, pageSize: 10 }}
        displayValue={displayValue}
        onSelect={onSelect}
      />
    </>
  )
}

export default TransactionReferenceLookup
